import type { Theme, Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  // ▼▼▼▼▼▼▼▼ 🎨 STYLE ▼▼▼▼▼▼▼▼
  styleOverrides: {
    root: ({ theme }) => ({
      borderRadius: 8,
      '&:hover': {
        backgroundColor: theme.vars.palette.action.hover,
      },
      '&.Mui-disabled': {
        color: theme.vars.palette.action.disabled,
      },
      // Ripple effect with 8px border radius
      '& .MuiTouchRipple-root': {
        borderRadius: 8,
      },
      '& .MuiTouchRipple-child': {
        borderRadius: 8,
      },
      '& .MuiTouchRipple-rippleVisible': {
        borderRadius: 8,
      },
    }),
    sizeSmall: {
      padding: 4,
    },
    sizeMedium: {
      padding: 8,
    },
    sizeLarge: {
      padding: 12,
    },
  },
};

/* **********************************************************************
 * 🚀 Export
 * **********************************************************************/
export const iconButton: Components<Theme> = {
  MuiIconButton,
};
